export default __webpack_public_path__ + "static/media/poison_messages_card.f181df00.jpg";